import React, {
	memo,
	useCallback,
	useMemo
} from 'react';
import PropTypes from 'prop-types';

import { log } from '../../../../../../services/utils';

import { useAgencyState } from '../../../../../../contexts/AgenciesContext';

import Actions from '../../../../../Shared/Actions';
import HelpModal from '../../../../../Shared/HelpModal';
import PageHeader from '../../../../../Shared/PageHeader';
import Table from '../../../../../Table';
import DateCell from '../../../../../Table/Cells/DateCell';
import TableRowActions from '../../../../../Table/Cells/TableRowActions';
import MultiSelectColumnFilter from '../../../../../Table/ColumnFilters/MultiSelectColumnFilter';
import multiSelectFilterFn from '../../../../../Table/filterFunctions/multiSelectFilterFn';
import multiWordFilterFn from '../../../../../Table/filterFunctions/multiWordFilterFn';
import dateFilterFn from '../../../../../Table/filterFunctions/dateFilterFn';

const ProgramsTable = ( { setProgram } ) => {
	const { agency } = useAgencyState();

	const startDateCell = useCallback( ( { row } ) => <DateCell date={ row.original.startDate } />, [] );

	const endDateCell = useCallback( ( { row } ) => <DateCell date={ row.original.endDate } />, [] );

	const onView = useCallback( program => {
		setProgram( program );
	}, [ setProgram ] );

	const tableRowActionsCell = useCallback( ( { row } ) => {
		const actions = [
			{
				action: onView,
				componentProps: { color: 'pink' },
				icon: 'search',
				permission: true,
				text: 'View Program'
			}
		];

		return (
			<TableRowActions
				actions={ actions }
				row={ row.original }
			/>
		);
	}, [ onView ] );

	const columns = useMemo( () => [
		{
			accessor: 'name',
			Header: 'Program Name',
			filter: multiWordFilterFn,
			minWidth: 60
		},
		{
			id: 'type',
			accessor: row => `${ row.type }`,
			Header: 'Program Type',
			Filter: MultiSelectColumnFilter,
			filter: multiSelectFilterFn,
			minWidth: 60
		},
		{
			accessor: 'startDate',
			Header: 'Start Date',
			filter: dateFilterFn,
			Cell: startDateCell,
			minWidth: 60
		},
		{
			accessor: 'endDate',
			Header: 'End Date',
			filter: dateFilterFn,
			Cell: endDateCell,
			minWidth: 60
		},
		{
			id: 'submissionStatus',
			accessor: row => `${ row.submissionStatus }`,
			Header: 'Program Status',
			Filter: MultiSelectColumnFilter,
			filter: multiSelectFilterFn,
			minWidth: 60
		},
		{
			id: 'id_actions',
			Cell: tableRowActionsCell,
			disableFilters: true,
			disableResizing: true,
			width: 100,
			minWidth: 100,
			maxWidth: 100
		}
	], [
		endDateCell,
		startDateCell,
		tableRowActionsCell
	] );

	return (
		<>
			{ log( 'ProgramsTable' ) }
			<Actions />
			<PageHeader
				title={
					<>
						<span>Agency Programs</span>
						<HelpModal
							id={ 28 }
							triggerStyles={ { verticalAlign: 'top' } }
						/>
					</>
				}
			/>
			<div className="table-container">
				{ agency?.programs?.length
					? <Table
						columns={ columns }
						data={ agency.programs }
						showCount={ agency.programs.length > 10 }
						showEmptyRows={ false }
						showPagination={ agency.programs.length > 10 }
					/>
					: 'No records found'
				}
			</div>
		</>
	);
};

ProgramsTable.propTypes = { setProgram: PropTypes.func.isRequired };

export default memo( ProgramsTable );
